import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';

import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {useQueryParams} from 'presentation/pages';
import {getOdontoAvailableTimes} from '../../services/getOdontoAvailableTimes';

import {ODONTO_AVAILABLE_TIMES_STALE_TIME} from '../useGetOdontoAvailableTimesQuery/constants';
import {UseGetOdontoMultiAvailableTimesQueryProps} from './types';

export function useGetOdontoMultiAvailableTimesQuery({
	enabled,
	dates,
}: UseGetOdontoMultiAvailableTimesQueryProps) {
	const bookingData = useBookingStore(state => state.bookingData);
	const {
		SEARCH_PARAMS: {shift, disability},
	} = useQueryParams();

	const availableTimesParams = {
		cdAtendimentoAcessoEspecial: disability,
		cdEspecialidade: Number(bookingData.specialtyCode),
		cdPrestadorJuridico: Number(bookingData.unitCode),
		cdUf: bookingData.ufCode.toUpperCase(),
		nmCidade: bookingData.cityName.toUpperCase(),
		cdSubEspecialidade: bookingData.subSpecialtyCode ? Number(bookingData.subSpecialtyCode) : 0,
		nmBairro: bookingData.odontoUnitDistrictSelected
			? bookingData.odontoUnitDistrictSelected.toUpperCase()
			: undefined,
		filtroTurno: shift,
	};

	return useQuery({
		queryKey: [QUERY_KEYS.ODONTO_AVAILABLE_TIMES, availableTimesParams, dates],
		queryFn: async ({signal}) => {
			const firstThreeDates = dates?.slice(0, 3) ?? [];

			const availableTimes = await Promise.allSettled(
				firstThreeDates?.map(date =>
					getOdontoAvailableTimes({
						signal,
						...availableTimesParams,
						dataConsulta: date,
					}),
				),
			);

			const formattedAvailableTimes = availableTimes
				.map((result, index) => ({
					date: firstThreeDates[index],
					times: result.status === 'fulfilled' ? result.value : [],
				}))
				.filter(item => item.times.length > 0);

			return formattedAvailableTimes;
		},
		enabled,
		staleTime: ODONTO_AVAILABLE_TIMES_STALE_TIME,
	});
}
